<template>
	<div class="TemplateVariableEditor" >

		<!-- <p>Click on a variable below to insert it into the configuration template</p> -->
		<div class="addbuttonrow" >
			<button type="button" @click.prevent="addVariable()" class="btn-white btn-small" ><i class="fa fa-plus-circle btn_icon"></i>New Variable</button>
		</div>
		<!-- <div class="divider"></div> -->

		<draggable 
			v-if="expanded_variables.length" 
			class="variables_list" 
			v-model="expanded_variables" 
			v-bind="dragOptions"
			@end="drag=false" 
			handle=".handle" 
			
		>
			<transition-group
				type="transition"
				:name="(!pause_animation&&!drag) ? 'flip-list' : null"
			>
					<div 
						v-for="variable in expanded_variables"
						:key="variable.lid"
						class="variable"
						@dragstart="startDrag(variable, $event)" 
					>
            <div class="var_body" >
							
							<div class="name" >
								{{variable.label}}
							</div>
							
							<div class="type" >
								{{variable.type}}
							</div>

							<div class="actions">
								<button type="button" class="main" @click.prevent="$emit('command',{label:'body-insert-variable',data:variable})" >
									<i class="fa fa-chevron-left btn_icon"></i> Insert
								</button>
								<button type="button" @click.prevent="editVariable(variable)"  >
									<i class="fa fa-pencil-alt btn_icon"></i> Edit
								</button>
								<button type="button"  @click.prevent="deleteVariable(variable)" >
									<i class="fa fa-trash-alt btn_icon"></i> Delete
								</button>
							</div>

							<template v-if="variable.subvariables" >
								
								<button type="button" class="moreoptions" @click.prevent="toggleOpenSubvar(variable.lid)" >{{ variable.subvariables.length }} inferred values</button>

								<ul v-if="isOpen(variable.lid)" class="subvariables">
									<li v-for="subvariable in variable.subvariables"  :key="subvariable.id" >
										<div>
											<span class="subvar_name">{{ subvariable.label }}</span>
											<br>
											<span class="subvar_example">e.g. {{ subvariable.calculate(variable.default_value || '192.168.0.1/24') }}</span>
										</div>
										<button type="button" @click.prevent="$emit('command',{label:'body-insert-variable',data:subvariable})" >
											<i class="fa fa-chevron-left"></i>
										</button>
									</li>
								</ul>

							</template>

						</div>
            <div class="handle" ></div>
					</div>

			</transition-group>
		</draggable>

		<div v-else class="novariables" >
			Add your first variable to get started
		</div>
		
	</div>
</template>

<script>

	import EditVariable from '../modals/EditVariable';
	import Variables from '../utils/Variables';
	
	import draggable from 'vuedraggable'

	export default {

		props : ['value'],

		components : {
			EditVariable,
			draggable,
		},

		data(){
			return {
				addVal : '',
				open_variables : [],
				variables : [],
				expanded_variables : [],
				order : [],
				drag : false,
				pause_animation : false,
				dragOptions : {
						animation: 200,
						group: "varlist",
						disabled: false,
						ghostClass: "ghost"
				},
			}
		},

		computed:{
			display_variables : function(){
				return Variables.expand(this.variables);
			}
		},

		beforeMount(){
			this.refreshFromVal();
		},

		watch: {
			value : function(){
				this.refreshFromVal();
			},
			variables(){
				this.expanded_variables = Variables.expand(this.variables);
				console.log(this.expanded_variables);
			},
			expanded_variables(){
				var self = this;
				var current_order = self.variables.map(x=>x.lid);
				var new_order = self.expanded_variables.map(x=>x.lid);
				if(current_order.join('.') != new_order.join('.')){
					self.variables = new_order.map(lid=>self.variables.find(v=>v.lid==lid));
					self.$emit('input', self.variables);
				}
			},
		},

		methods:{

			startDrag(variable,event) {
				this.drag=true;
				event.dataTransfer.setData('text/html','<span class="variable" data-variable-id="'+variable.lid+'" >'+variable.label+'</span>')
			},

			toggleOpenSubvar(lid) {
				var self = this;
				self.pause_animation = true;
				if(this.isOpen(lid)){
					this.open_variables = this.open_variables.filter(x=>x!=lid);
				} else {
					this.open_variables.push(lid);
				}
				setTimeout(function(){
					self.pause_animation = false;
				},200);
			},

			isOpen(lid) {
				return this.open_variables.includes(lid);
			},

			command(cdata){
				switch( (cdata||{}).label ){
					case 'create-var-and-insert':
						var variable = {};
						if(((cdata||{}).data||{}).query) variable.label = cdata.data.query;
						this.addVariable(variable,true);
						break;
					case 'xvariabletag-add':
						var tag = (cdata||{}).data;
						if(tag) this.addVariable(tag);
						break;
				}
			},

			refreshFromVal(){
				this.variables = (this.value || []).map(v=>{
					if(!v.lid)v.lid=this.newLocalID();
					return v;
				});
			},

			// tidyVariableLabel : function(string){
			// 	string = string.trim();
			// 	string = string.replace(/[^A-Za-z0-9._]/g,'_');
			// 	return string;
			// },

			// handleAddForm : function(e){
			// 	var label = this.tidyVariableLabel(this.addVal);
			// 	this.addVariable(label);
			// 	this.addVal = '';
			// },

			// addVariable : function(label){
			// 	var existing_index =  this.variables.findIndex((v)=> v == label);
			// 	var prop = label;
			// 	if(existing_index === -1){
			// 		this.variables.push(prop);
			// 	} else {
			// 		this.variables.splice(existing_index,1,prop);
			// 	}
			// 	this.$emit('input', this.variables);

			// },

			variableFormSubmit( variable, payload ){
				var self = this;
				
				return new Promise(function(resolve,reject){

					variable = Object.assign(variable,payload);

					var index = self.variables.findIndex((p) => p.lid == variable.lid);
					if(index == -1){
						self.variables.push(variable)
					} else {
						 self.variables.splice(index,1, variable)
					}

					self.$emit('input', self.variables);
					Event.$emit('modal-close');

					resolve(variable);
				})
			},

			newLocalID(){
				return _.uniqueId('lid-'+ Date.now() +'-');
			},

			deleteVariable(variable){
				var index = this.variables.findIndex((p) => p.lid == variable.lid);
				if(index != -1){
					 this.variables.splice(index,1);
					 this.$emit('input', this.variables);
				}
			},

			addVariable( variable , thenInsert = false ){
				var self = this;
				Event.$emit('modal-open', {
					component : EditVariable,
					props : {
						variable,
						variables : self.variables,
						onSubmit : function(payload){
							return self.variableFormSubmit({ lid : self.newLocalID() },payload).then(function(variable){
								if(thenInsert){
									self.$emit('command',{label:'body-insert-variable',data:variable})
								}
								return variable;
							});
						},
					},
				});
			},

			editVariable(variable){
				var self = this;

				Event.$emit('modal-open', {
					component : EditVariable,
					props : {
						variable,
						variables : self.variables,
						onSubmit : function(payload){
							return self.variableFormSubmit(variable,payload);
						},
					},
				});
			},

		}
	}

</script>